import {CategoryDetailPageContext} from '../../../types';
import {TrackingClientStateHolder} from '../helpers/clientState';
import {trackContentView} from './trackContentView';

export const trackCategoryView =
  ({page}: {page: CategoryDetailPageContext}) =>
  (clientState: TrackingClientStateHolder) => {
    return trackContentView({
      page,
    })(clientState);
  };
